module.exports = __webpack_public_path__ + "static/media/ico-exit.f8e1078d.svg";